import {createUUID4} from "../../../../../helper/uuid";

export default class Canvas {
    id = '';
    container = 'magic-canvas';
    canvas = null;
    canvasJson = null;
    canvasJsonPreview = null;
    mask = null;
    activeTool = 'freeDrawingBrush';
    settings = {
        freeDrawingBrush: {
            width:  100
        },
    };
    jsonLoading = false;
    historyIndex = 0;
    history = [];

    constructor() {
        this.id = createUUID4();
    }
}
